import React from "react";
import { Card, Badge, Image, Row, Col } from "react-bootstrap";

const TaskCard1 = ({ task }) => {
  return (
    <Card
      className="task-card-box p-3 mx-auto mb-3"
      style={{ borderRadius: "20px", backgroundColor: "#F7F7F7" }}
    >
      <Row>
        <Col className="d-flex align-items-center">
          <Badge bg={task.typeClass}>{task.type}</Badge>
        </Col>
        <Col className="text-end">
          <Badge bg={task.statusClass}>{task.status}</Badge>
        </Col>
      </Row>

      <Card.Text className="mt-2">{task.description}</Card.Text>

      <div>
        <p className="mb-1">
          <b>Assigned By:</b> {task.assignedBy}{" "}
          <Badge bg="secondary">{task.priority}</Badge>
        </p>

        <p className="mb-1">
          <b>Assigned To:</b>
          <div className="d-flex">
            {task.assignedTo.map((id) => (
              <Image
                key={id}
                src={`https://i.pravatar.cc/40?img=${id}`}
                roundedCircle
                className="me-1"
              />
            ))}
          </div>
        </p>

        <p className="mb-1">
          <b>Approved By:</b>
          <div className="d-flex">
            {task.approvedBy.map((id) => (
              <Image
                key={id}
                src={`https://i.pravatar.cc/40?img=${id}`}
                roundedCircle
                className="me-1"
              />
            ))}
          </div>
        </p>
      </div>
    </Card>
  );
};

export default TaskCard1;
